import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { SCHOOL_NAV } from "./SchoolDashboard";
import api from "@/lib/api";
import { ShieldCheck, Store, Info } from "lucide-react";

export default function SchoolVendors() {
  const [suppliers, setSuppliers] = useState([]);
  useEffect(() => { api.get("/vendors").then((r) => setSuppliers(r.data)); }, []);
  return (
    <DashboardLayout nav={SCHOOL_NAV} title="Approved Suppliers">
      <div className="mb-4 rounded-md border border-blue-100 bg-blue-50 text-brand-blue text-sm p-3 flex items-start gap-2">
        <Info size={16} className="mt-0.5" />
        <div>
          <div className="font-semibold">Confidential Procurement Mode is active.</div>
          <div className="text-brand-blueDark/80">SchoolLane brokers every transaction. You will only see anonymised supplier references; SchoolLane handles all direct communication and pricing negotiation with suppliers on your behalf.</div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {suppliers.map((s) => (
          <div key={s.id} className="sl-card p-5" data-testid={`supplier-${s.supplier_ref}`}>
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-lg grid place-items-center ${s.supplier_tier === "Preferred Supplier" ? "bg-emerald-50 text-brand-green" : "bg-blue-50 text-brand-blue"}`}>
                {s.supplier_tier === "Preferred Supplier" ? <ShieldCheck size={18} /> : <Store size={18} />}
              </div>
              <div>
                <h3 className="font-heading font-semibold text-slate-900 font-mono text-sm">{s.supplier_ref}</h3>
                <div className={`text-xs font-semibold ${s.supplier_tier === "Preferred Supplier" ? "text-brand-greenDark" : "text-brand-blue"}`}>{s.supplier_tier}</div>
              </div>
            </div>
            <p className="mt-3 text-sm text-slate-600 leading-relaxed">
              Fulfilment SLA {s.supplier_tier === "Preferred Supplier" ? "≤5 business days" : "≤10 business days"}. SchoolLane routes every RFQ and PO through this supplier while masking their identity.
            </p>
          </div>
        ))}
        {suppliers.length === 0 && <div className="sl-card p-8 text-center text-slate-500 md:col-span-3">No suppliers available.</div>}
      </div>
    </DashboardLayout>
  );
}
